<template>
  <div class="childPageTemp">
    <div class="childPageTemp_banner">
      <div class="childPageTemp_banner_content">
        <img v-if="wWidth > 768" src="../assets/PaginationBanner.png" alt />
        <img
          v-if="wWidth < 768"
          src="../assets/mobile/PaginationBanner_Mobile@2x.png"
          alt
        />
        <div
          :class="`childPageTemp_title childPageTemp_title_${$i18n.locale}`"
        >
          <div>{{ title }}</div>
        </div>
      </div>
    </div>
    <div class="childPageTemp_content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "ChildPageTemp",
  data() {
    return {};
  },
  computed: {
    wWidth() {
      return this.$store.state.wWidth;
    },
    // title() {
    //   const serviceTypeConfig = this.$store.state.serviceTypeConfig;
    //   const serviceTitle = this.$route.meta.serviceTitle;
    //   let serviceName =
    //     (serviceTypeConfig &&
    //       serviceTypeConfig[`name${this.$t("message.lan")}`]) ||
    //     "";
    //   return serviceTitle
    //     ? `${this.$t(serviceTitle)}\n${serviceName}`
    //     : serviceName;
    // },
    title() {
      const serviceTypeConfig = this.$store.state.serviceTypeConfig;
      const serviceType = serviceTypeConfig && serviceTypeConfig.serviceType;
      const serviceName =
        (serviceTypeConfig &&
          serviceTypeConfig[`name${this.$t("message.lan")}`]) ||
        "";
      let msg = "";
      switch (serviceType) {
        case "HZMB_G_FIRST":
        case "HZMB_G_RENEW":
        case "HZMB_G_CANCEL":
        case "HZMB_G_INSURANCE":
          msg = `${this.$t("hzmbG.title.hzmbG")}\n${serviceName}`;
          break;
        case "HZMB_H_FIRST":
        case "HZMB_H_CANCEL":
        case "HZMB_H_FIRST_PERSON":
        case "HZMB_H_RENEW_PERSON":
        case "HZMB_H_CANCEL_PERSON":
        case "HZMB_H_FIRST_COMP":
        case "HZMB_H_RENEW_COMP":
        case "HZMB_H_CANCEL_COMP":
        case "HZMB_H_BOOKING":
          msg = `${this.$t("message.entries.home.hzmbH")}\n${serviceName}`;
          break;
        default:
          msg = serviceName;
          break;
      }
      return msg;
    },
  },
  methods: {
    btnClick(path) {
      this.$router.push(path);
    },
  },
  created() {
    // this.title = this.$t(
    //   `message.entries.home.${localStorage.getItem("childTempTitle") || "one"}`
    // );
  },
};
</script>

<style lang="scss" scoped>
.childPageTemp {
  width: 100%;
}
.childPageTemp_content {
  // max-width: 1440px;
  width: 100%;
  margin: auto;
}
.childPageTemp_title div {
  justify-content: flex-start;
}
@media screen and (max-width: 1300px) {
  .childPageTemp_title div {
    font-size: 42px;
    line-height: 58px;
  }
}
@media screen and (max-width: 996px) {
  .childPageTemp_title div {
    font-size: 30px;
    line-height: 44px;
  }
}
@media screen and (max-width: 767px) {
  .childPageTemp_banner div {
    font-size: 22px;
    line-height: 35px;
  }
}
</style>
